import { TranslatePipe } from '../../filters/translate.pipe';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import Session from '../../utils/session.service';
import RoutingService from '../../services/routing.service';

@Component({
	standalone: true,
	selector: 'audiobooks',
	templateUrl: './audiobooks.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule, RouterLink ]
})
export default class AudiobooksView implements OnInit {
	private session: Session = inject(Session);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('booking').then(() => {
			this.vm.user = this.session.getSession().user;
			
			var lang: any = this.vm.user.deviceLanguage || 'en_GB';
			if (lang == 'en_GB' || lang == 'et_EE' || lang == 'ru_RU' || lang == 'fi_FI') {
				this.vm.appLogoLang = lang.split("_")[0];
			} else {
				this.vm.appLogoLang = 'en';
			}
			
			if (this.vm.user.origin == 'siffi.com') {
				this.vm.androidLink = 'https://play.google.com/store/apps/details?id=com.siffi&hl=' + this.vm.appLogoLang;
				this.vm.iosLink = 'https://apps.apple.com/app/siffi/id1629846508?platform=iphone';
			} else {
				this.vm.androidLink = 'https://play.google.com/store/apps/details?id=ee.minudoc&hl=' + this.vm.appLogoLang;
				this.vm.iosLink = 'https://apps.apple.com/app/minudoc/id1465732931?platform=iphone';
			}
		}).catch(console.error);
	}
	
}